import React from 'react';
import { Button, Menu, MenuItem, Box } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation(); // Prevenir propagación al drawer
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    handleClose();
  };

  return (
    <Box onClick={(e) => e.stopPropagation()}>
      <Button
        id="language-switcher-button"
        startIcon={<LanguageIcon />}
        onClick={handleClick}
        sx={{
          color: 'text.primary',
          fontWeight: 700,
          textTransform: 'uppercase',
          fontSize: '0.875rem',
          border: '2px solid',
          borderColor: 'primary.main',
          borderRadius: 2,
          px: 2,
          minWidth: '80px',
          '&:hover': {
            bgcolor: 'primary.main',
            color: 'white',
            borderColor: 'primary.main'
          }
        }}
      >
        {i18n.language === 'es' ? 'ES' : 'EN'}
      </Button>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disableScrollLock={true}
        disableRestoreFocus
        disableAutoFocusItem
        MenuListProps={{
          'aria-labelledby': 'language-switcher-button',
        }}
        slotProps={{
          paper: {
            onTouchStart: (e) => e.stopPropagation(),
          }
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={{
          mt: 1,
          '.MuiPaper-root': {
            bgcolor: 'background.paper',
            border: '2px solid',
            borderColor: 'primary.main',
            borderRadius: 2,
            minWidth: '150px'
          },
          '& .MuiBackdrop-root': {
            backgroundColor: 'transparent',
          }
        }}
      >
        <MenuItem 
          onClick={() => changeLanguage('es')}
          selected={i18n.language === 'es'}
          sx={{ 
            fontWeight: i18n.language === 'es' ? 700 : 400,
            minHeight: 48,
            '&.Mui-selected': {
              bgcolor: 'primary.main',
              color: 'white',
              '&:hover': {
                bgcolor: 'primary.dark'
              }
            }
          }}
        >
          🇪🇸 Español
        </MenuItem>
        <MenuItem 
          onClick={() => changeLanguage('en')}
          selected={i18n.language === 'en'}
          sx={{ 
            fontWeight: i18n.language === 'en' ? 700 : 400,
            minHeight: 48,
            '&.Mui-selected': {
              bgcolor: 'primary.main',
              color: 'white',
              '&:hover': {
                bgcolor: 'primary.dark'
              }
            }
          }}
        >
          🇺🇸 English
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default LanguageSwitcher;
